export default Object.freeze({
  PENDING: 'PENDING',
  VALIDATED: 'VALIDATED',
  REFUSED: 'REFUSED',
});
